import React from "react";
import { useContent } from "../hooks/useContent";
import { imageUrls } from "../lib/supabase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faHeartPulse,
  faUserDoctor,
  faStethoscope,
} from "@fortawesome/free-solid-svg-icons";

const AboutUs = () => {
  // Dynamic content from Supabase
  const { content: sectionTitle } = useContent(
    "about_section_title",
    "home",
    "Despre noi"
  );
  const { content: mainTitle } = useContent(
    "about_main_title",
    "home",
    "Centrul Medical Ali Cranta"
  );
  const { content: description1 } = useContent(
    "about_description_1",
    "home",
    "Conceptul modern aplicat în tratarea fiecărui caz asigură redobândirea sănătății pacientului și promovează un stil de viață sănătos."
  );
  const { content: description2 } = useContent(
    "about_description_2",
    "home",
    "La centrul medical ALI CRANTA, primordial în filosofia clinicii noastre este redobândirea sănătății pacientului și asigurarea vitalității acestuia prin prevenție și adoptarea unui stil de viață sănătos și echilibrat fizic și emoțional."
  );

  return (
    <section
      className="section about-section"
      id="about-us"
    >
      <div className="container">
        <h2 className="section-title">{sectionTitle}</h2>

        <div className="row align-items-center mb-5">
          <div className="col-lg-6">
            <div className="about-content">
              <h3 className="mb-4">{mainTitle}</h3>
              <p className="about-p">{description1}</p>
              <p className="about-p">{description2}</p>

              <div className="about-features">
                <div className="feature-item">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="feature-icon"
                  />
                  <p>Echipamente medicale de ultimă generație</p>
                </div>
                <div className="feature-item">
                  <FontAwesomeIcon
                    icon={faHeartPulse}
                    className="feature-icon"
                  />
                  <p>Abordare centrată pe nevoile pacientului</p>
                </div>
                <div className="feature-item">
                  <FontAwesomeIcon
                    icon={faUserDoctor}
                    className="feature-icon"
                  />
                  <p>Medici cu vastă experiență în domeniu</p>
                </div>
                <div className="feature-item">
                  <FontAwesomeIcon
                    icon={faStethoscope}
                    className="feature-icon"
                  />
                  <p>Proceduri medicale la standarde înalte</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-images">
              <div className="row g-3">
                <div className="col-6">
                  <img
                    src={imageUrls.cabinet1()}
                    alt="Cabinet medical 1"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="col-6">
                  <img
                    src={imageUrls.cabinet2()}
                    alt="Cabinet medical 2"
                    className="img-fluid rounded"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
